import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_history_anthem.breadcrumb.application_history_anthem_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_history_anthem.breadcrumb.application_history_anthem_label2'),
    link: '/application/history',
  },
  {
    label: t('pages.application_history_anthem.breadcrumb.application_history_anthem_label3'),
  },
];
